export default class DataProvider {
    constructor(items) {
        this.items = items;
    }
}
